import PropTypes from "prop-types";

export const RolesIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M9.667 2.837L5.51 4.403c-.958.359-1.742 1.492-1.742 2.509v6.192c0 .983.65 2.275 1.442 2.866l3.583 2.675c1.175.884 3.109.884 4.284 0l3.583-2.675c.792-.591 1.442-1.883 1.442-2.867V6.913c0-1.025-.784-2.159-1.742-2.517l-4.158-1.558c-.709-.259-1.842-.259-2.534 0z"></path>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M8.467 10.87l1.342 1.342 3.583-3.583"></path>
    </svg>
  );
};

RolesIcon.propTypes = {
  active: PropTypes.bool
};
